export const DART_TYPES = {
    SINGLE: 'S',
    DOUBLE: 'D',
    TRIPLE: 'T',
    BULL: 'B.E',
    OUTER_BULL: 'B',
    MISS: 'Miss',
    INVALID: 'Invalid',
}

export const DART_TYPE_MULTIPLIERS = {
    [DART_TYPES.SINGLE]: 1,
    [DART_TYPES.DOUBLE]: 2,
    [DART_TYPES.TRIPLE]: 3,
}

export const DART_TYPE_FIXED_VALUES = {
    [DART_TYPES.BULL]: 50,
    [DART_TYPES.OUTER_BULL]: 25,
    [DART_TYPES.MISS]: 0,
    [DART_TYPES.INVALID]: 0,
}
